import React, { Fragment } from 'react';

import PlayerLink from '@nhl/nhl-react-ui/lib/PlayerLink';

import GlobalColumnFunctions from '../../../../../../../utils/globalColumnFunctions';
import BaseColumnDefinitions from '../baseColumnDefinitions';

// Shortening the function name
const { CreateHeaderCell } = BaseColumnDefinitions;

// Columns

const SKATER_PLAYER_COL = {
    Header: CreateHeaderCell('Player Name', 'Player', { textAlign: 'left' }),
    headerClassName: 'name left',
    className: 'name left',
    accessor: 'lastName',
    Cell: ({ original }) => (
        <Fragment>
            <PlayerLink
                player={original}
                title={original.isActive === 1 ? 'Active Player' : null}
                className={original.isActive === 1 ? 'strong' : ''}
            />
            {original.activeStreak && <span title="Streak is Active" className="active-indicator-icon" />}
        </Fragment>
    ),
    sortType: (a, b) => a.original.lastName.toUpperCase().localeCompare(b.original.lastName.toUpperCase()),
    minWidth: window.innerWidth > 414 ? 150 : 130,
    getProps: GlobalColumnFunctions.getProps,
};
//point streaks
const TWO_POINTS_STREAK_COL = {
    accessor: 'twoPlusPoints',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('2+ PTS'),
};

const THREE_POINTS_STREAK_COL = {
    accessor: 'threePlusPoints',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('3+ PTS'),
};

const FOUR_POINTS_STREAK_COL = {
    accessor: 'fourPlusPoints',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('4+ PTS'),
};

const FIVE_POINTS_STREAK_COL = {
    accessor: 'fivePlusPoints',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('5+ PTS'),
};

//goal streaks
const TWO_GOALS_STREAK_COL = {
    accessor: 'twoPlusGoals',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('2+ GOALS'),
};

const THREE_GOALS_STREAK_COL = {
    accessor: 'threePlusGoals',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('3+ GOALS'),
};

const FOUR_GOALS_STREAK_COL = {
    accessor: 'fourPlusGoals',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('4+ GOALS'),
};

const FIVE_GOALS_STREAK_COL = {
    accessor: 'fivePlusGoals',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('5+ GOALS'),
};

//assist streaks
const TWO_ASSISTS_STREAK_COL = {
    accessor: 'twoPlusAssists',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('2+ ASSISTS'),
};

const THREE_ASSISTS_STREAK_COL = {
    accessor: 'threePlusAssists',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('3+ ASSISTS'),
};

const FOUR_ASSISTS_STREAK_COL = {
    accessor: 'fourPlusAssists',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('4+ ASSISTS'),
};

const FIVE_ASSISTS_STREAK_COL = {
    accessor: 'fivePlusAssists',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('5+ ASSISTS'),
};

// Column Groupings
const PERFORMANCE_STREAK_BASE_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    SKATER_PLAYER_COL,
    BaseColumnDefinitions.POSITION_COL,
    BaseColumnDefinitions.TEAM_COL,
    BaseColumnDefinitions.SEASON_COL,
    { ...BaseColumnDefinitions.GAMES_PLAYED_COL, Header: CreateHeaderCell('Games Played', 'TOTAL GP') },
];

const PERFORMANCE_STREAK_CAREER_BASE_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    SKATER_PLAYER_COL,
    BaseColumnDefinitions.POSITION_COL,
    { ...BaseColumnDefinitions.TEAM_ABBREVS, accessor: 'teamAbbrev' },
    { ...BaseColumnDefinitions.GAMES_PLAYED_COL, Header: CreateHeaderCell('Games Played', 'TOTAL GP') },
];

const REGULAR_SEASON_POINT_STREAK_COLS = [
    TWO_POINTS_STREAK_COL,
    THREE_POINTS_STREAK_COL,
    FOUR_POINTS_STREAK_COL,
    FIVE_POINTS_STREAK_COL,
];

const REGULAR_SEASON_GOAL_STREAK_COLS = [
    TWO_GOALS_STREAK_COL,
    THREE_GOALS_STREAK_COL,
    FOUR_GOALS_STREAK_COL,
    FIVE_GOALS_STREAK_COL,
];

const REGULAR_SEASON_ASSIST_STREAK_COLS = [
    TWO_ASSISTS_STREAK_COL,
    THREE_ASSISTS_STREAK_COL,
    FOUR_ASSISTS_STREAK_COL,
    FIVE_ASSISTS_STREAK_COL,
];

const PLAYOFF_SEASON_POINT_STREAK_COLS = [TWO_POINTS_STREAK_COL, THREE_POINTS_STREAK_COL, FOUR_POINTS_STREAK_COL];

const PLAYOFF_SEASON_GOAL_STREAK_COLS = [TWO_GOALS_STREAK_COL, THREE_GOALS_STREAK_COL, FOUR_GOALS_STREAK_COL];

const PLAYOFF_SEASON_ASSIST_STREAK_COLS = [TWO_ASSISTS_STREAK_COL, THREE_ASSISTS_STREAK_COL, FOUR_ASSISTS_STREAK_COL];

const SEASON_POINT_STREAK_COLS = [...PERFORMANCE_STREAK_BASE_COLS, ...REGULAR_SEASON_POINT_STREAK_COLS];
const SEASON_GOAL_STEAK_COLS = [...PERFORMANCE_STREAK_BASE_COLS, ...REGULAR_SEASON_GOAL_STREAK_COLS];
const SEASON_ASSIST_STEAK_COLS = [...PERFORMANCE_STREAK_BASE_COLS, ...REGULAR_SEASON_ASSIST_STREAK_COLS];
const SEASON_POINT_STREAK_PLAYOFF_COLS = [...PERFORMANCE_STREAK_BASE_COLS, ...PLAYOFF_SEASON_POINT_STREAK_COLS];
const SEASON_GOAL_STEAK_PLAYOFF_COLS = [...PERFORMANCE_STREAK_BASE_COLS, ...PLAYOFF_SEASON_GOAL_STREAK_COLS];
const SEASON_ASSIST_STEAK_PLAYOFF_COLS = [...PERFORMANCE_STREAK_BASE_COLS, ...PLAYOFF_SEASON_ASSIST_STREAK_COLS];

export const skaterMultiPerformancesColumnDefinitions = {
    //Multi-performances
    'multi-point-games-career': [...PERFORMANCE_STREAK_CAREER_BASE_COLS, ...REGULAR_SEASON_POINT_STREAK_COLS],
    'multi-point-games-rookie-season': SEASON_POINT_STREAK_COLS,
    'multi-goal-games-career': [...PERFORMANCE_STREAK_CAREER_BASE_COLS, ...REGULAR_SEASON_GOAL_STREAK_COLS],
    'multi-goal-games-rookie-season': SEASON_GOAL_STEAK_COLS,
    'multi-assist-games-career': [...PERFORMANCE_STREAK_CAREER_BASE_COLS, ...REGULAR_SEASON_ASSIST_STREAK_COLS],
    'multi-assist-games-rookie-season': SEASON_ASSIST_STEAK_COLS,
    'multi-point-games-career-playoffs': [...PERFORMANCE_STREAK_CAREER_BASE_COLS, ...PLAYOFF_SEASON_POINT_STREAK_COLS],
    'multi-point-games-rookie-playoff-year': SEASON_POINT_STREAK_PLAYOFF_COLS,
    'multi-goal-games-career-playoffs': [...PERFORMANCE_STREAK_CAREER_BASE_COLS, ...PLAYOFF_SEASON_GOAL_STREAK_COLS],
    'multi-goal-games-rookie-playoff-year': SEASON_GOAL_STEAK_PLAYOFF_COLS,
    'multi-assist-games-career-playoffs': [
        ...PERFORMANCE_STREAK_CAREER_BASE_COLS,
        ...PLAYOFF_SEASON_ASSIST_STREAK_COLS,
    ],
    'multi-assist-games-rookie-playoff-year': SEASON_ASSIST_STEAK_PLAYOFF_COLS,
    '2-point-games-season': [...PERFORMANCE_STREAK_BASE_COLS, TWO_POINTS_STREAK_COL],
    '3-point-games-season': [...PERFORMANCE_STREAK_BASE_COLS, THREE_POINTS_STREAK_COL],
    '4-point-games-season': [...PERFORMANCE_STREAK_BASE_COLS, FOUR_POINTS_STREAK_COL],
    '5-point-games-season': [...PERFORMANCE_STREAK_BASE_COLS, FIVE_POINTS_STREAK_COL],
    '2-goal-games-season': [...PERFORMANCE_STREAK_BASE_COLS, TWO_GOALS_STREAK_COL],
    '3-goal-games-season': [...PERFORMANCE_STREAK_BASE_COLS, THREE_GOALS_STREAK_COL],
    '4-goal-games-season': [...PERFORMANCE_STREAK_BASE_COLS, FOUR_GOALS_STREAK_COL],
    '5-goal-games-season': [...PERFORMANCE_STREAK_BASE_COLS, FIVE_GOALS_STREAK_COL],
    '2-assist-games-season': [...PERFORMANCE_STREAK_BASE_COLS, TWO_ASSISTS_STREAK_COL],
    '3-assist-games-season': [...PERFORMANCE_STREAK_BASE_COLS, THREE_ASSISTS_STREAK_COL],
    '4-assist-games-season': [...PERFORMANCE_STREAK_BASE_COLS, FOUR_ASSISTS_STREAK_COL],
    '5-assist-games-season': [...PERFORMANCE_STREAK_BASE_COLS, FIVE_ASSISTS_STREAK_COL],
    '2-point-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, TWO_POINTS_STREAK_COL],
    '3-point-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, THREE_POINTS_STREAK_COL],
    '4-point-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, FOUR_POINTS_STREAK_COL],
    '2-goal-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, TWO_GOALS_STREAK_COL],
    '3-goal-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, THREE_GOALS_STREAK_COL],
    '4-goal-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, FOUR_GOALS_STREAK_COL],
    '2-assist-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, TWO_ASSISTS_STREAK_COL],
    '3-assist-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, THREE_ASSISTS_STREAK_COL],
    '4-assist-games-playoff-year': [...PERFORMANCE_STREAK_BASE_COLS, FOUR_ASSISTS_STREAK_COL],
};
